import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full overflow-hidden pt-[133%]">
        <img
          src={comic.cover}
          alt={`${comic.title} 封面`}
          title={`${comic.title} 妖精题材漫画`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${
            comic.status === "连载"
              ? "bg-secondary-500 text-background-50"
              : "bg-accent-500 text-background-50"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-0.5 text-xs text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {comic.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="truncate text-base font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {comic.author}
          </span>
          <span className="text-background-300">|</span>
          <span>{comic.category}</span>
        </div>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{comic.intro}</p>
        <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-bookmark-line"></i>
            更新至第 {comic.latestChapter} 话
          </span>
          <span>{comic.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}